import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Route, withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import Navigation from "./Navigation/Navigation";
import ModalRouter from "./ModalRouter";

export class App extends Component {
  render() {
    const { children, identity, location } = this.props;
    const { pathname } = location;

    return (
      <div>
        <Helmet>
          <title>{`Mercury`}</title>
        </Helmet>
        {pathname === "/" && (
          <Navigation user={identity} location={location} accountId="" />
        )}
        <Route
          path="/clients/:accountId"
          render={(props) => (
            <Navigation
              user={identity}
              location={location}
              accountId={props.match.params.accountId}
            />
          )}
        />
        {children}
        <ModalRouter />
      </div>
    );
  }
}

// Connect state data
function mapStateToProps(state) {
  return {
    identity: state.auth.identity,
  };
}

// Connect actions
export default compose(withRouter, connect(mapStateToProps, {}))(App);
